export var Duration;
(function (Duration) {
    Duration[Duration["THREE_YEARS"] = 3] = "THREE_YEARS";
})(Duration || (Duration = {}));
(function (Duration) {
    function createOptions(_t) {
        return [Duration.THREE_YEARS].map((value) => ({
            label: value.toString(),
            value,
        }));
    }
    Duration.createOptions = createOptions;
})(Duration || (Duration = {}));
export var RecruiterVoucher;
(function (RecruiterVoucher) {
    RecruiterVoucher["AMAZON"] = "Amazon";
    RecruiterVoucher["CARE"] = "Spende an CARE";
    RecruiterVoucher["ZALANDO"] = "Zalando";
})(RecruiterVoucher || (RecruiterVoucher = {}));
(function (RecruiterVoucher) {
    function createOptions(t) {
        return [
            {
                label: t('wheelie:form.enum.recruiter_voucher.amazon'),
                value: RecruiterVoucher.AMAZON,
            },
            {
                label: t('wheelie:form.enum.recruiter_voucher.care'),
                value: RecruiterVoucher.CARE,
            },
            {
                label: t('wheelie:form.enum.recruiter_voucher.zalando'),
                value: RecruiterVoucher.ZALANDO,
            },
        ];
    }
    RecruiterVoucher.createOptions = createOptions;
})(RecruiterVoucher || (RecruiterVoucher = {}));
